import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useRule } from '@/features/rules/useRule'
import RuleForm from '../components/RuleForm'

const EditRule = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { useUpdateRule, useFetchRule } = useRule()

  const updateRule = useUpdateRule()
  const { data: rule } = useFetchRule(id)

  const onSubmit = async (data) => {
    const newData = {
      ...data,
    }
    delete newData.employeeNumber
    delete newData.fullName

    updateRule.mutate(
      { id, data: newData },
      {
        onSuccess: () => {
          navigate('/admin/rules')
        },
      }
    )
  }

  return <RuleForm onSubmitAction={onSubmit} rule={rule} />
}

export default EditRule
